import _ from 'lodash'

export default function (ctx) {
  const {req,store} = ctx;
  let appySite = {};
  if (req?.headers?.host !== undefined &&
    req.headers.host !== null &&
    /.*appylife\.com.*/ig.test(req.headers.host)
  ) {
    appySite = {
      site: 'AL',
      domain: 'appylife.com',
    }
  }
  else {
    appySite = {
      site: 'AC',
      domain: 'appycouple.com'
    }
  }
  if (req?.headers?.["user-agent"] !== undefined &&
    req.headers["user-agent"] !== null
  ) {
    appySite.userAgent = req.headers["user-agent"];
  }
  store.commit('setSiteData', appySite)
}
